// Procedural ambient soundscape — a soft wind bed + occasional gentle birdsong. No audio assets.
// Starts on the first user gesture (browser autoplay policy); master gain is gated by the mute setting
// (store.graphics.muted). Deliberately tiny: one looping noise buffer + short scheduled sine chirps.
import { store } from '../core/store.js';
import { bus } from '../core/bus.js';

let ctx = null, master = null, started = false, birdTimer = null;
const VOL = 0.5;

function isMuted() { const g = store.get().graphics; return g ? !!g.muted : false; }

function chirp() {
  if (!ctx || isMuted()) return;
  const t = ctx.currentTime;
  const notes = 2 + (Math.random() * 3 | 0);
  const base = 1500 + Math.random() * 1300;
  for (let i = 0; i < notes; i++) {
    const o = ctx.createOscillator(); o.type = 'sine';
    const g = ctx.createGain();
    const tt = t + i * 0.09;
    o.frequency.setValueAtTime(base * (1 + i * 0.05 * (Math.random() > 0.5 ? 1 : -1)), tt);
    g.gain.setValueAtTime(0, tt);
    g.gain.linearRampToValueAtTime(0.045, tt + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, tt + 0.14);
    o.connect(g); g.connect(master); o.start(tt); o.stop(tt + 0.16);
  }
}

function scheduleBird() {
  clearTimeout(birdTimer);
  birdTimer = setTimeout(() => { chirp(); scheduleBird(); }, 4000 + Math.random() * 9000);
}

function start() {
  if (started) return;
  started = true;
  try {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
    master = ctx.createGain();
    master.gain.value = isMuted() ? 0 : VOL;
    master.connect(ctx.destination);

    // Wind bed: looping brown-ish noise through a gentle low-pass, slowly swelling.
    const len = ctx.sampleRate * 3;
    const buf = ctx.createBuffer(1, len, ctx.sampleRate);
    const d = buf.getChannelData(0);
    let last = 0;
    for (let i = 0; i < len; i++) { const w = Math.random() * 2 - 1; last = (last + 0.02 * w) / 1.02; d[i] = last * 3.0; }
    const src = ctx.createBufferSource(); src.buffer = buf; src.loop = true;
    const lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 430;
    const windGain = ctx.createGain(); windGain.gain.value = 0.08;
    src.connect(lp); lp.connect(windGain); windGain.connect(master);
    src.start();
    const lfo = ctx.createOscillator(); lfo.frequency.value = 0.05;
    const lfoGain = ctx.createGain(); lfoGain.gain.value = 0.035;
    lfo.connect(lfoGain); lfoGain.connect(windGain.gain); lfo.start();

    scheduleBird();
  } catch { started = false; }
}

export function initAmbience() {
  bus.on('audio:muted', (m) => { if (master && ctx) master.gain.setTargetAtTime(m ? 0 : VOL, ctx.currentTime, 0.12); });
  const kick = () => { start(); if (ctx && ctx.state === 'suspended') ctx.resume(); };
  window.addEventListener('pointerdown', kick);
  window.addEventListener('keydown', kick);
}
